/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ThresholdDetailsModel {
    getFixupPrototypeFunction() { return ThresholdDetailsModel.fixupPrototype; }

    static newInstance(model: Partial<ThresholdDetailsModel>): ThresholdDetailsModel {
        let obj = Object.assign(new ThresholdDetailsModel(), model);
        ThresholdDetailsModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ThresholdDetailsModel>): ThresholdDetailsModel {
        if (!model) return null;
        return ThresholdDetailsModel.newInstance(<ThresholdDetailsModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ThresholdDetailsModel) {
        if (!obj) return;

        models.ThresholdDetailsModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ThresholdDetailsModel): boolean {
        Object.setPrototypeOf(obj, ThresholdDetailsModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.threshold_percentage === undefined) {
            this.threshold_percentage = 0;
        }
        if (this.alert_notification_details) {
            models.ThresholdNotificationConfigurationModel.fixupPrototype(this.alert_notification_details);
        }
        if (this.alert_action_details) {
            models.ThresholdActionConfigurationModel.fixupPrototype(this.alert_action_details);
        }
    }

    /**
     * threshold percentage
     */
    threshold_percentage: number;

    /**
     * threshold name
     */
    threshold_name: string;

    /**
     * alert notification details
     */
    alert_notification_details: models.ThresholdNotificationConfigurationModel;

    /**
     * Configuration type
     */
    configuration_type: string;

    /**
     * alert action details
     */
    alert_action_details: models.ThresholdActionConfigurationModel;

    /**
     * tenant id
     */
    tenant_id: string;

    /**
     * Name of the user who created the threshold alert.
     */
    created_by: string;

    /**
     * Created time to create threshold alert
     */
    created_at: string;

    /**
     * Name of the user who updated the the threshold alert.
     */
    updated_by: string;

    /**
     * Updated time to create threshold alert
     */
    updated_at: string;

    /**
     * Threshold alert id which can be retrieved from View Budget Threshold Alerts API
     */
    id: string;

}
